export function updatePageHeight() {
  const footer = document.querySelector('footer')
  const pageHeight = document.body.scrollHeight
  const footerHeight = footer ? footer.offsetHeight : 0
  const calculatedHeight = pageHeight - footerHeight
  document.documentElement.style.setProperty('--page-height', `${calculatedHeight}px`)
}
